import React, { Component } from 'react';
import './CustomCheckSelector.css'
import {injectIntl} from "react-intl";
import { addItemSelect, removeItemSelect } from "../../actions/MultiselectAction";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class CustomCheckSelector extends Component {
  handleSelectItem = (e) => {
    e.stopPropagation();
    const { addItemSelect, removeItemSelect, itemHover, keyCollection, selectedFiles } = this.props;
    // Sin filtro por `isContent`: la selección múltiple no es sólo de derechos
    // de uso. Se usa para descargar, mover, compartir y eliminar, y para todo
    // eso una carpeta o un comprimido son destinos válidos.
    //
    // El guard que había acá bloqueaba todo lo que no fuera "pieza de
    // contenido", y una carpeta NUNCA lo es (buildIsContentPieceExpression sólo
    // acepta image/video/audio, document con extensión de contenido y
    // other=indd/prproj). Resultado: no se podía marcar ninguna carpeta y había
    // que entrar y seleccionar archivo por archivo.
    //
    // El recorte por tipo, cuando corresponde, lo hace el backend al asignar
    // derechos, y el modal lo informa en la fila "No aplican por tipo".
    const isSelected = selectedFiles.some(x => x._id === itemHover._id);
    if (!isSelected) {
      addItemSelect(itemHover, keyCollection);
    } else {
      removeItemSelect(itemHover, keyCollection);
    }
  }

  render() {
    const {
      isHover,
      k,
      indice,
      selectedFiles,
      itemHover,
      from,
      inList,
      folderOrBunker,
      newColor
    } = this.props;

    const isSelected = selectedFiles.some(x => x._id === itemHover._id);

    if ((isHover && `${from}-${k}` === indice) || isSelected) return (
      <div
        className="custom-select-hitbox"
        onMouseEnter={this.props.handleOnMouseEnter}
        onMouseLeave={this.props.handleOnMouseLeave}
        onClick={this.handleSelectItem}
      >
        <div 
         className={`custom-select ${isSelected ? "open" : ""}`}

          style = {{
            top: inList ? "12px" : "5px",
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: folderOrBunker ? "white": newColor
          }}
        >
          
          </div>
      </div>
    )
    else return null;
  }
}

const mapStateToProps = (state) => {
  return {
    selectedFiles: state.selectedFiles.data,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {
  addItemSelect,
  removeItemSelect,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomCheckSelector)))
